import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UsuarioProvider } from '../providers/usuario.provider';

export abstract class BaseService {

    router: Router;
    storage: Storage;
    usuarioProvider: UsuarioProvider;
    _baseUrl = environment.urlBaseNova;

    private mensagemTimeout = 'Não foi possível realizar sua solicitação. Tente novamente mais tarde.';
    private mensagemErro = 'Não foi possível realizar sua solicitação.';
    private mensagemLoginNovamente = 'Favor realizar o login novamente';
    private mensagemErroLogin = 'E-mail ou Senha Inválidos';

    constructor() {
    }

    async autenticar(login: string, senha: string): Promise<any> {

        const header = {
            'X-Authorization': `Basic ${btoa(login + ':' + senha)}`,
            'Content-Type': 'application/x-www-form-urlencoded'
        };

        const body = null;
        const url = this._baseUrl + '/autenticacao/token-acesso';

        let response: any;
        try {
            response = await this.montarPost(url, body, header);
        } catch (error) {
            throw this.tratarErroServico(url, error);
        }

        return JSON.parse(response.data);
    }

    get(url: string, withCache: boolean = true, newApi: boolean = false, urlCoorporativo: boolean = false): Observable<any> {
        return new Observable((observer) => {
            this.getCache(url, withCache).then((dados: any) => {
                if (dados) {
                    observer.next(dados);
                }
                this.tratarUrl(urlCoorporativo, newApi);
                return this.montarGet(this._baseUrl + url, this.montarOptions(url));
            }).then((response: any) => {
                if (response.status === 204) {
                    observer.next();
                } else {

                    let retorno: any;
                    try {
                        retorno = JSON.parse(response.data);
                    } catch (e) {
                        retorno = response.data;
                    }

                    if (withCache) {
                        this.storage.set(url, retorno);
                    }
                    observer.next(retorno);
                }
                observer.complete();
            }).catch((error: any) => {
                console.log(error);
                observer.error(this.tratarErroServico(url, error));
                observer.complete();
            });
        });
    }

    private tratarUrl(urlCoorporativo: boolean, newApi: boolean) {
        this._baseUrl = environment.urlBaseNova;
        if (urlCoorporativo) {
            this._baseUrl = environment.urlBaseCoorporativo;
        }

        if (newApi) {
            this._baseUrl = environment.urlBaseNova;
        }
    }

    private async getCache(url: string, withCache: boolean) {
        if (withCache) {
            try {
                const dados: string = await this.storage.get(url) || undefined;
                try {
                    return JSON.parse(dados);
                } catch (error) {
                    return dados;
                }
            } catch (error) {
                console.log('Erro Cache = ', error);
            }
        }
    }

    async postFile(url, file) {
        const options = this.montarOptions(url);
        delete options['Content-Type'];

        const formData = new FormData();
        formData.append('file', file);

        let response: any = null;
        try {
            response = await this.montarPost(this._baseUrl + url, formData, options);
        } catch (error) {
            throw this.tratarErroServico(url, error);
        }

        if (response && response.data) {
            response = JSON.parse(response.data);
            if (response.error) {
                throw this.tratarErroServico(url, response.error);
            }
        }

        return response;
    }

    async put(url: string, body: any): Promise<any> {
        const options = this.montarOptions(url);
        let response: any;
        try {
            this.tratarUrl(false, false);
            console.log('PUT =>', (this._baseUrl + url));
            response = await this.montarPut(this._baseUrl + url, body, options);
        } catch (error) {
            throw this.tratarErroServico(url, error);
        }

        if (response && response.data) {
            response = JSON.parse(response.data);
            if (response.error) {
                throw this.tratarErroServico(url, response.error);
            }
        }

        return response;
    }

    async post(url: string, body: any): Promise<any> {
        const options = this.montarOptions(url);
        let response: any;
        try {
            this.tratarUrl(false, false);
            console.log('POST =>:', (this._baseUrl + url));
            response = await this.montarPost(this._baseUrl + url, body, options);
        } catch (error) {
            throw this.tratarErroServico(url, error);
        }

        if (response && response.data) {
            response = JSON.parse(response.data);
            if (response.error) {
                throw this.tratarErroServico(url, response.error);
            }
        }

        return response;
    }

    async delete(url: string): Promise<any> {
        const options = this.montarOptions(url);
        let response: any;
        try {
            this.tratarUrl(false, false);
            // console.log('DELETE =>:', (this._baseUrl + url));
            response = await this.montarDelete(this._baseUrl + url, options);
        } catch (error) {
            throw this.tratarErroServico(url, error);
        }

        if (response && response.data) {
            response = JSON.parse(response.data);
            if (response.error) {
                throw this.tratarErroServico(url, response.error);
            }
        }

        return response;
    }

    private montarOptions(url: string, isFile: boolean = false) {
        const header = isFile ? {
            Accept: 'application/json, application/pdf',
            'Content-Type': 'application/pdf',
        } : {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        };

        const usuarioLogado = this.usuarioProvider.getUsuario();
        if (usuarioLogado) {
            // console.log(url);
            let headerNovo: any;
            if (usuarioLogado.perfil && usuarioLogado.esfera && (url.indexOf('scpa') === -1 && url.indexOf('corporativo') === -1)) {
                const splitEsfera = usuarioLogado.esfera.esferaAtuacao.split('/');
                const esfera = splitEsfera[splitEsfera.length - 1];
                headerNovo = {
                    Authorization: 'Bearer ' + this.usuarioProvider.getUsuario().token.accessToken,
                    'X-Role-UsuarioLogado': 'ROLE_CNES_' + (usuarioLogado.esfera.sigla == "ESTREC" ? usuarioLogado.esfera.sigla : usuarioLogado.perfil.sigla),
                    'X-Esfera-UsuarioLogado': usuarioLogado.esfera.sigla == "ESTREC" ? usuarioLogado.esfera.esferaAtuacao : esfera
                };
            } else {
                headerNovo = { Authorization: 'Bearer ' + this.usuarioProvider.getUsuario().token.accessToken };
            }
            Object.assign(
                header,
                headerNovo
            );
        }
        return header;
    }

    private tratarErroServico(url: string, responseError: any) {
        this.analyticsErroServico(url, responseError);
        if (responseError.status === 401 || responseError.status === 0) {
            this.usuarioProvider.setUsuario(null);
            this.router.navigate(['/login']);
            return new Error(this.mensagemLoginNovamente);
        } else if (responseError.error || responseError.events) {
            if ((responseError.error && responseError.error.toLowerCase)
                && (responseError.error.toLowerCase().indexOf('tempo limite') !== -1
                    || responseError.error.toLowerCase().indexOf('timed out') !== -1)) {
                return new Error(this.mensagemTimeout);
            } else if (responseError.status === 400 && url.includes('/oauth/token')) {
                return new Error(this.mensagemErroLogin);
            } else if (responseError.status === 400 && responseError.error.includes('exceptions') && !url.includes('marcacoes/lote')) {
                const response = JSON.parse(responseError.error).exceptions;
                let arErros = '';
                // tslint:disable-next-line:forin
                for (const index in response) {
                    // tslint:disable-next-line:max-line-length
                    arErros += index + ': ' + response[index].mensagem + ' - ' + response[index].caminho + ' - ' + response[index].valorRejeitado;
                }
                return new Error(arErros);
            } else if (responseError.status === 404) {
                const error = JSON.parse(responseError.error);
                if (error['mensagem-negocio'] && error['mensagem-negocio'].indexOf('message') > -1) {
                    return new Error(JSON.parse(error['mensagem-negocio']).message);
                } else {
                    return new Error('Registro não encontrado');
                }
            } else if (responseError.status === 422 || url.includes('marcacoes/lote')) {
                return responseError;
            } else {
                return new Error(this.getErrorMessage(responseError));
            }
        }
        return new Error(this.mensagemErro);
    }

    private getErrorMessage(responseError: any): string {
        let message: string;
        try {

            if (responseError.events) {
                message = responseError.events[0].message;
            } else if (responseError.error) {
                const error = JSON.parse(responseError.error);
                message = error.message;
            } else {
                message = responseError.message || responseError.error_description;
            }

        } catch (error) {
            message = responseError.error.message || responseError.error.error_description;
        }

        return message;
    }

    private analyticsErroServico(url: any, error: any) {
        // this.googleAnalytics.trackException(`${url} - ${error.status} - ${error.message}`, false);
    }

    abstract montarGet(url: string, headers: any): Promise<any>;

    abstract montarPost(url: string, body: any, headers: any): Promise<any>;

    abstract montarPut(url: string, body: any, headers: any): Promise<any>;

    abstract montarDelete(url: string, headers: any): Promise<any>;

}
